import moment from 'moment';
import CreditReportClient from '@/api/CampusAdmin/CreditReportsClient';

const PageBy = {
  WhenDesc: 'WhenDesc'
};
const EntryType = {
  Individual: 'Individual',
  Workshop: 'Workshop',
};
export default class CreditLedgerReport {

  constructor() {
    this.creditReportClient = null;
    this.schoolId = 0;

    this.entries = [];

    this.loading = false;
    this.parameters = {
      from: null,
      through: null,
      type: EntryType.Individual,
      pageToken: PageBy.WhenDesc,
      customCampusTags: []
    };
  }

  get hasNext() {
    return !this.isNoToken() && !this.isStarterToken();
  }

  initialize($http, schoolId) {
    this.creditReportClient = new CreditReportClient($http);
    this.schoolId = schoolId;

    return this;
  }

  asIndividual() {
    this.parameters.pageToken = PageBy.WhenDesc;
    this.parameters.type = EntryType.Individual;

    return this;
  }
  asWorkshop() {
    this.parameters.pageToken = PageBy.WhenDesc;
    this.parameters.type = EntryType.Workshop;

    return this;
  }
  between(from, through) {
    this.parameters.pageToken = PageBy.WhenDesc;
    this.parameters.from = from ? moment(from).toISOString() : null;
    this.parameters.through = through ? moment(through).toISOString() : null;

    return this;
  }
  
  async fetch() {

    try {
      this.loading = true;

      if(this.isNoToken() || this.isStarterToken())
        this.entries.length = 0;

      const response = await this.creditReportClient.getLedgerReport({
        schoolId: this.schoolId,
        ...this.parameters
      });

      this.parameters.pageToken = response.nextPageToken;
      this.entries.push(...response.entries);

    } finally {
      this.loading = false;
    }
  }

  isNoToken() {
    return !this.parameters.pageToken;
  }

  isStarterToken() {
    for(const val in PageBy)
      if(val === this.parameters.pageToken)
        return true;
    return false;
  }
  withCustomTags(tagsList) {
    this.parameters.customCampusTags = tagsList;
    return this;
  }
}